import { render, staticRenderFns } from "./Dingdoc.vue?vue&type=template&id=25c64e0c&scoped=true"
import script from "./Dingdoc.vue?vue&type=script&lang=js"
export * from "./Dingdoc.vue?vue&type=script&lang=js"
import style0 from "./Dingdoc.vue?vue&type=style&index=0&id=25c64e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c64e0c",
  null
  
)

export default component.exports